/* ============================================================
   SENARAI SHORTCUT "/" — bacaan hidup
   ============================================================
   Dipakai oleh DUA skrin: PRO Studio → Shortcut / (urus) dan
   popup Edit Prompts di Workspace (pilih dengan "/"). Satu hook
   supaya kedua-duanya mustahil terpesong — shortcut yang dipadam
   di PRO Studio terus hilang daripada senarai "/".

   Akses (claim percuma) BUKAN di sini — lihat `useCiriPercuma`.
   `hidup` — beri `false` untuk langsung tidak membaca.
   ============================================================ */

import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';

import { db, auth } from '../firebase';
import { SHORTCUT_COL, bandingShortcut } from '../utils/shortcutStore';

export function useSenaraiShortcut(hidup = true) {
    const [keadaan, setKeadaan] = useState({ senarai: [], sudahMuat: false, ralat: '' });

    useEffect(() => {
        const uid = auth.currentUser?.uid;
        if (!hidup || !uid) return undefined;
        return onSnapshot(
            collection(db, 'users', uid, SHORTCUT_COL),
            (snap) => {
                const senarai = snap.docs
                    .map((d) => ({ ...(d.data() || {}), id: d.id }))
                    .filter((x) => x.nama && String(x.teks || '').trim())
                    .sort(bandingShortcut);
                setKeadaan({ senarai, sudahMuat: true, ralat: '' });
            },
            (e) => {
                /* Gagal baca → skrin memberitahu (bukan senyap "belum ada shortcut"),
                   supaya pelanggan tidak menyangka shortcut dia sudah hilang. */
                console.warn('[Shortcut] gagal baca senarai:', e?.message);
                setKeadaan({ senarai: [], sudahMuat: true, ralat: e?.code || 'gagal' });
            }
        );
    }, [hidup]);

    return hidup ? keadaan : { senarai: [], sudahMuat: false, ralat: '' };
}
